import { useLimuloIsTheSource } from '@/hooks/useLimuloIsTheSource';
import { crLinkDaLimulo, type CrLinkDaLimulo } from '@/lib/limulo/crLink';
import { useGetLimuloGamesQuery, useGetLimuloProfilesQuery } from '@/services/limuloApi';

/**
 * «L'utente ha il profilo Clash Royale?» quando la fonte e' Limulo — per Decks e Battles.
 *
 * Fuori dal ramo le due query sono in `skip` (nessuna chiamata a Limulo) e l'esito e'
 * `{ kind: 'off' }`: chi chiama decide come prima. La derivazione e' pura, in
 * `lib/limulo/crLink.ts`.
 */
export function useCrLinkDaLimulo(): CrLinkDaLimulo {
  const isTheSource = useLimuloIsTheSource();
  // `activeOnly: true` ESPLICITO, come QBot: «attivo» lo decide il server, non un default del BFF ne'
  // un letterale nostro (revisione di #506, 2° giro, 🟡8).
  const profili = useGetLimuloProfilesQuery({ activeOnly: true }, { skip: !isTheSource });
  const giochi = useGetLimuloGamesQuery(undefined, { skip: !isTheSource });
  return crLinkDaLimulo(isTheSource, profili, giochi);
}
